import { CustomForm, CustomFormArray, CustomFormGroup } from "@tilby/tilby-ui-lib/components/tilby-magic-form";
import { ProvValidator } from "@tilby/tilby-ui-lib/utilities";
import { Components, ComponentsCategories } from "tilby-models";

export class ComponentsFe implements Components {
    id: number = 0;
    name: string = "";
    price_difference?: number = 0;
}

export type ComponentsFields = Components;

export type ComponentsFieldsNullable = { [prop in string & keyof ComponentsFields]: ComponentsFields[prop] | null };
export type ComponentsForm = Partial<CustomForm<ComponentsFieldsNullable>>;

export type ComponentsFormGroups = CustomFormGroup<ComponentsWithCustomCategories>;

export type ComponentsWithCustomCategories = Omit<ComponentsForm, 'categories'> & {
    categories?: CustomFormArray<CustomFormGroup<ComponentsCategoriesFormArray>>;
}

export type ComponentsCategoriesFormArray = Partial<CustomForm<ComponentsCategoriesFields>>;
export type ComponentsCategoriesFields = ComponentsCategoriesExtended;

export type ComponentsCategoriesExtended = ComponentsCategories & {
    checked?: boolean
}

export interface ComponentsValidators extends ProvValidator {
    nameMaxLength: number;
}

export const filterableComponentsColumnsWithSearchBar: (keyof ComponentsFe)[] = ["name"];
